module.exports = __webpack_public_path__ + "img/folder.31453ae9.svg";